
// These imports work because we are using @rollup/plugin-url.
// See package.json and rollup.config.js

import connectorUrl from './connector.vef'
import blueUrl from './blue.vef'
import yellowUrl from './yellow.vef'
import redUrl from './red.vef'
import greenUrl from './green.vef'
import blackUrl from './black.vef'
import maroonUrl from './maroon.vef'
import spruceUrl from './spruce.vef'
import roseUrl from './rose.vef'
import purpleUrl from './purple.vef'
import brownUrl from './brown.vef'
import sandUrl from './sand.vef'
import coralUrl from './coral.vef'
import navyUrl from './navy.vef'
import sulfurUrl from './sulfur.vef'
import cinnamonUrl from './cinnamon.vef'
import turquoiseUrl from './turquoise.vef'
import oliveUrl from './olive.vef'
import appleUrl from './apple.vef'
import lavenderUrl from './lavender.vef'
import orangeUrl from './orange.vef'

const shapes = {
  connector: connectorUrl,
  blue: blueUrl,
  yellow: yellowUrl,
  red: redUrl,
  green: greenUrl,
  black: blackUrl,
  maroon: maroonUrl,
  spruce: spruceUrl,
  rose: roseUrl,
  purple: purpleUrl,
  brown: brownUrl,
  sand: sandUrl,
  coral: coralUrl,
  navy: navyUrl,
  sulfur: sulfurUrl,
  cinnamon: cinnamonUrl,
  turquoise: turquoiseUrl,
  olive: oliveUrl,
  apple: appleUrl,
  lavender: lavenderUrl,
  orange: orangeUrl,
}

export default shapes